<template>
  <v-container v-if="list">
    <v-row no-gutters align="center" justify="end">
      <v-col v-if="list.length">
        <v-row align="center">
          <v-btn
            small
            text
            @click="togglePanels(list.map((item, itemIndex) => itemIndex))"
          >
            Развернуть все
          </v-btn>
          <v-divider vertical />
          <v-btn small text @click="togglePanels"> Свернуть все </v-btn>
        </v-row>
      </v-col>
      <v-spacer />
      <v-menu
        v-if="multipleCreating && (availableItems || availableItems.length)"
        transition="scroll-y-transition"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on">
            <v-icon class="pr-1"> mdi-plus </v-icon>
            <span>Добавить</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, itemIndex) in availableItems"
            :key="itemIndex"
            @click="$emit('add', item)"
          >
            {{ item.title }}
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn v-else @click="$emit('add', availableItems[0])">
        <v-icon class="pr-1"> mdi-plus </v-icon>
        <span>Добавить</span>
      </v-btn>
    </v-row>
    <v-row>
      <v-expansion-panels multiple class="list-group" :value="expansionPanels">
        <draggable
          :value="list"
          handle=".handle"
          class="row no-gutters"
          @start="togglePanels"
          @input="$emit('list-sort', $event)"
        >
          <!-- <transition-group class="row no-gutters"> -->
          <v-expansion-panel
            class="mb-5 list-group-item"
            v-for="(item, itemIndex) in list"
            :key="itemIndex"
          >
            <v-expansion-panel-header>
              <v-row align="center">
                <v-col cols="1">
                  <v-btn
                    v-if="sortAvailable"
                    class="handle mr-2"
                    icon
                    @click.stop.prevent="() => {}"
                  >
                    <v-icon> mdi-cursor-move </v-icon>
                  </v-btn>
                </v-col>
                <v-col>
                  <p
                    :class="[
                      item.data.hidden ? 'grey--text' : '',
                      errorMessages[itemIndex] !== undefined ? 'error--text' : ''
                    ]"
                  >
                    {{ item.title || item.data.title || itemIndex + 1 }}
                  </p>
                  <p>{{ getTitle(item) }}</p>
                  <p v-if="item.data.hidden" class="ml-2 grey--text">(скрыт)</p>
                </v-col>
              </v-row>
              <template #actions>
                <v-menu transition="scroll-y-transition" offset-y>
                  <template #activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click.stop.prevent="() => {}">
                      <v-icon> mdi-dots-vertical </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      dense
                      v-for="(option, optionIndex) in options"
                      :key="optionIndex"
                      :style="{ [option.borderDirection]: option.borderStyle }"
                      @click="optionHandler(option, itemIndex, item)"
                    >
                      {{ option.title }}
                      <span v-if="copyClipboard.title">
                        {{
                          option.showClipboardCopyTitle ? `(${copyClipboard.title})` : ''
                        }}
                      </span>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <slot name="item" :data="{ item, itemIndex }" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- </transition-group> -->
        </draggable>
      </v-expansion-panels>
    </v-row>
    <ConfirmationDialog ref="confirm" confirmText="ОК" />
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
// import { commonWidgetList } from '@/utils/widgets'
import ConfirmationDialog from '@/components/confirmation-dialog'

const widgetsListWithoutTitle = [
  'TextWidget',
  'SpacerWidget',
  'GalleryWidget',
  'MapWidget',
  'StandartEventsFeedWidget',
  'IntroEventsFeedWidget',
  'SliderEventsFeedWidget',
  'EventsPlacesRelationChosenWidgetInput',
  'PagesFeedWidget',
  'BlogFeedWidget',
  'PlacesFeedWidget',
  'CitiesFeedWidget',
  'RoutesFeedWidget',
  'AudioGuidesFeedWidget',
  'AdPlacementWidget',
  'HotelsFeedWidget',
  'CardsSetWidget',
  'VideoWidget',
  'TextAndImageWidget'
]

export default {
  name: 'DynamicListWrapper',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    copyClipboard: {
      type: Object,
      default: () => ({})
    },
    errorMessages: {
      type: Object,
      default: () => ({})
    },
    availableItems: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    multipleCreating: {
      type: Boolean,
      default: true
    },
    sortAvailable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    draggable,
    ConfirmationDialog
  },
  data () {
    return {
      expansionPanels: []
    }
  },
  methods: {
    togglePanels (list = []) {
      this.expansionPanels = list
    },
    async optionHandler (option, itemIndex, item) {
      const { isConfirm, isManual } = option
      if (isConfirm && this.$refs.confirm) await this.$refs.confirm.open()
      if (!isManual) this.$emit('option', option, itemIndex, item)
      else this.$emit('option-manual', option, itemIndex, item)
    },
    getTitle (item) {
      if (widgetsListWithoutTitle.includes(item?.type)) return ''
      if (item?.type === 'NavPillsWidget' || item?.type === 'NavPillsLargeWidget') {
        return item?.data?.pills.reduce((acc, el) => {
          acc = acc + ' ' + el.data.title
          return acc
        }, ' ')
      }
    }
  }
}
</script>
